export const getWorkflowFormData = (taskId: string, file: any) => {
  const formData = new FormData();
  formData.append('taskId', taskId);
  formData.append('content', file);
  formData.append('fileName', file.name);
  return formData;
};

export const getAttachmentFormData = (nodeRef: string, file: any) => {
  const formData = new FormData();
  formData.append('_assocType', 'ctbd:attachement');
  formData.append('_nodeType', 'ctbd:baseDoc');
  formData.append('_parent', nodeRef);
  formData.append('_content', file, file.name);
  formData.append('prop_cm_name', file.name);
  return formData;
};
